import { Link } from 'react-router-dom';
import { Comic, hotComics } from '@/mocks/comics';

function ComicCard({ comic }: { comic: Comic }) {
  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-200 transition-all overflow-hidden cursor-pointer"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden">
        <img
          src={comic.coverImage}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 rounded-full bg-primary-500/90 text-white text-xs font-medium">
            {comic.rating}
          </span>
        </div>
        {comic.status === '连载中' && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 rounded-full bg-accent-500/90 text-white text-xs font-medium">
              {comic.status}
            </span>
          </div>
        )}
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
          <span className="text-white/90 text-xs">
            <i className="ri-eye-line mr-1"></i>{(comic.views / 10000).toFixed(0)}万
          </span>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author} · {comic.chapters}话</p>
        <div className="flex flex-wrap gap-1 mt-2">
          {comic.tags.slice(0, 2).map((tag) => (
            <span key={tag} className="px-1.5 py-0.5 rounded-md bg-secondary-100 text-secondary-700 text-xs">
              {tag}
            </span>
          ))}
        </div>
      </div>
    </Link>
  );
}

export default function HotComics() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900">
            热门推荐
          </h2>
          <p className="text-sm text-foreground-500 mt-1">读者最爱的精选漫画</p>
        </div>
        <Link to="/category/fantasy" className="text-sm text-primary-500 hover:text-primary-600 transition-colors flex items-center gap-1 whitespace-nowrap">
          查看更多 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {hotComics.map((comic) => (
          <ComicCard key={comic.id} comic={comic} />
        ))}
      </div>
    </section>
  );
}